export const formatCurrency = (currency, number) => {
    return new Intl.NumberFormat(navigator.language || 'sv-SE', {
        style: 'currency',
        currency: currency
    }).format(number);
};

export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const getCookies = () => {
    return document.cookie.split(';').reduce((cookies, cookie) => {
        const [name, value] = cookie.trim().split('=');
        cookies[name] = value;
        return cookies;
    }, {});
};

export const removeCookie = (name, domain) => {
    document.cookie = `${name}=; Max-Age=-99999999;`;
    if (domain) {
        document.cookie = `${name}=; Max-Age=-99999999; domain=${domain}`;
    }
};

export const setCookie = (name, value, daysToExpire) => {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + daysToExpire);
    document.cookie = `${name}=${value}; expires=${expirationDate.toUTCString()}; path=/`;
};

export function debounce(func, wait) {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}

export const kebabize = (str) => str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? "-" : "") + $.toLowerCase())

export const timeFormatter = (dateString) => {
    const date = new Date(dateString);
    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: 'UTC'
    };

    return new Intl.DateTimeFormat('sv-SE', options).format(date);
};

export const timeFormatterShort = (dateString) => {
    const date = new Date(dateString);
    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'UTC'
    };

    return new Intl.DateTimeFormat('sv-SE', options).format(date);
};
